<div class="app-rewards app-stations-list">
  <div class="rewards-list">
    <div *ngFor="let reward of rewards()" class="reward-item" (click)="openRewardPopup(reward)">
      <div class="icon">
        <img src="assets/rewards/{{ reward.rewardType }}.svg" alt="{{ reward.rewardType }}">
      </div>
      <p class="reward-name">{{ getRewardName(reward) }}</p>
      <p class="date">{{ reward?.createdDate ? getRewardDate(reward.createdDate) : '' }}</p>
    </div>
  </div>

  <div class="stations-loading" *ngIf="rewards() === undefined">
    <mat-spinner [diameter]="20"></mat-spinner> Loading...
  </div>
</div>
